import moment from 'moment';
import { config } from '../constants/domainConfig';
import qs from "querystring";
export const console_log = (param1, param2) => {
    if (param2) {
        console.log(param1, param2);
    } else {
        console.log(param1);
    }
};

export const parseQueryString = (url) => {
    var urlParams = {};
    url.replace(
        new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        function($0, $1, $2, $3) {
            urlParams[$1] = $3;
        }
    );

    return urlParams;
};

export const jsUcfirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatDate = (date) => {
    return moment(date).format("DD MMM YYYY");
};

export const appendUid = (route, uid) => {
    if (uid) {
        let val = `${route}?uid=${uid}`;
        return val;
    }
    else return route;
}

let authorizedData=sessionStorage.getItem("authorized")?JSON.parse(sessionStorage.getItem("authorized")):null;
export const loggedInDetail=authorizedData

export const shuffle=(videoArray)=> {
    let ctr = videoArray.length;
    let temp;
    let index;

    // While there are elements in the array
    while (ctr > 0) {
// Pick a random index
        index = Math.floor(Math.random() * ctr);
// Decrease ctr by 1
        ctr--;
// And swap the last element with it
        temp = videoArray[ctr];
        videoArray[ctr] = videoArray[index];
        videoArray[index] = temp;
    }
    return videoArray;
}

export const filterGames = (game) => {
    if (((config.subDomain == 'iq' || config.subDomain == 'asiacell') && game.gameImage.indexOf('Batch+2') == -1) || (config.subDomain != 'iq' || config.subDomain == 'asiacell')){
        return true
    }
    return false
}

export const validURL = (str) => {
    const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (regexp.test(str)) {
        return true;
    }
    else {
        return false;
    }
}
const hashToQuery = () => {
    let d = window.location.hash.slice(1);
    d = d.split("?");
    return d[d.length-1];
};

const keysLowerCase = (obj) => {
    const keys = Object.keys(obj)
    let n = keys.length
    let res = {}
    while(n--){
        res[keys[n].toLowerCase()] = obj[keys[n]]
    }
    return res;
}

export const getParameters = (params) => {
    const queryStrings = keysLowerCase(qs.parse(window.location.search.slice(1)));
    const hashQueryStrings = keysLowerCase(qs.parse(hashToQuery()));
    const d = queryStrings[params] || hashQueryStrings[params];
    return {
        exist: d && d.length > 0 ? true : false,
        value: d
    };
};




// WEBPACK FOOTER //
// ./src/utils/helper.js